import { Link, useLocation } from "react-router-dom";
import classNames from "clsx";

export type Props = {
	name: string;
	route: string;
	secondOptionActive?: boolean;
};

export function TabsWithRoute({ name, route, secondOptionActive }: Props) {
	const location = useLocation();

	return (
		<li className="nav-item">
			<Link
				className={classNames(
					"nav-link text-active-primary me-6",
					(location.pathname === route || secondOptionActive) && "active"
				)}
				to={route}
			>
				{name}
			</Link>
		</li>
	);
}
